import ApiERP from '@/core/conectores/ApiERP';
import { IFiltroGenerico } from '@/core/models/BuscaAvancada/IFiltroGenerico';
import { IItemConsultaRapida } from '@/core/models/Consulta/IItemConsultaRapida';
import { IListaPaginada } from '@/core/models/Consulta/IListaPaginada';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';
import { IPropriedadeConsulta } from '@/core/models/Consulta/PropriedadeConsulta';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { IServicoBase } from '@/core/models/IServicoBase';
import { IEngenhariaMateriaPrima, IEngenhariaProduto } from '@/models/Entidades/Cadastros/PCP/IEngenhariaProduto';

class ServicoEngenhariaProduto implements IServicoBase<IEngenhariaProduto> {
  endPoint= 'pcp-engenharia-produto';

  apiERP = new ApiERP();

  public requisicaoSistema(): void {
    this.apiERP = new ApiERP(true);
  }

  public async obterPropriedadesConsulta(): Promise<IPropriedadeConsulta[]> {
    const listaPropriedades = await this.apiERP.obterPropriedadesConsulta(this.endPoint);
    return listaPropriedades;
  }

  public async buscaAvancada(parametrosConsulta: IParametrosConsulta, filtros?: Array<IFiltroGenerico>): Promise<IListaPaginada> {
    return this.apiERP.buscaAvancada(this.endPoint, parametrosConsulta, filtros);
  }

  public async relatorioPadrao(tipoArquivo: ETipoArquivo, parametrosConsulta: IParametrosConsulta, filtros?: IFiltroGenerico[], codigosSelecionados?: Array<number>): Promise<IRetornoRelatorio> {
    return this.apiERP.relatorioPadrao(this.endPoint, tipoArquivo, parametrosConsulta, filtros, codigosSelecionados);
  }

  public async imprimirEtiquetaPadrao(codigoRegistro: number, empresa: number): Promise<IRetornoRelatorio> {
    const result: any = await this.apiERP.get(`${this.endPoint}/etiqueta/${codigoRegistro}/empresa/${empresa}`);
    return result.data;
  }

  public obterIdentificacaoRegistroGradeCRUD(objeto: IEngenhariaProduto): string {
    return objeto.nome;
  }

  public async consultaRapida(parametrosConsultaRapida: IParametrosConsultaRapida, codigoTipo?: number, codigoProdutoDefinicao?: number): Promise<IItemConsultaRapida[]> {
    let parametrosAdicionais = this.apiERP.obterParametrosAdicionaisConsultaRapida(parametrosConsultaRapida);
    parametrosAdicionais += `&codigoTipoProducao=${codigoTipo}`;
    parametrosAdicionais += `&codigoProdutoDefinicao=${codigoProdutoDefinicao}`;
    const result: any = await this.apiERP.get(`${this.endPoint}/consulta-rapida${parametrosAdicionais}`);
    return result.data;
  }

  public async incluir(objeto: IEngenhariaProduto): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}`, objeto);
    return result.data;
  }

  public async alterar(objeto: IEngenhariaProduto): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.put(`${this.endPoint}/${objeto.codigo}`, objeto);
    return result.data;
  }

  public async obter(codigo: number, empresa: number): Promise<IEngenhariaProduto> {
    const result: any = await this.apiERP.get(`${this.endPoint}/${codigo}/empresa/${empresa}`);
    return result.data;
  }

  public async excluir(codigo: number): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.delete(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async obterCustoProduto(codigo: number): Promise<number> {
    const result: any = await this.apiERP.get(`${this.endPoint}/custo-produto/${codigo}`);
    return result.data;
  }

  public async obterProdutoIntermediarioVinculado(codigoProduto: number): Promise<number> {
    const result: any = await this.apiERP.get(`${this.endPoint}/verificar-produto-intermediario/${codigoProduto}`);
    return result.data;
  }

  public async obterMPsProdutoIntermediario(codigoEngenhariaPI: number): Promise<IEngenhariaMateriaPrima[]> {
    const result: any = await this.apiERP.get(`${this.endPoint}/materias-primas-pi/${codigoEngenhariaPI}`);
    return result.data;
  }

  public async obterCodigoEngenhariaPorProdutoDefinicao(codigoProdutoDefinicao: number): Promise<number> {
    const result: any = await this.apiERP.get(`${this.endPoint}/codigo-engenharia-por-produto-definicao/${codigoProdutoDefinicao}`);
    return result.data;
  }
}
export default ServicoEngenhariaProduto;
